import { render, staticRenderFns } from "./message.vue?vue&type=template&id=6a8792cc&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=6a8792cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8792cc",
  null
  
)

export default component.exports